import { createContext } from 'react';
import { SIZES as BUTTON_SIZES } from '../Button/Button.constants';
const context = createContext({
    input: {
        size: 'medium',
    },
    button: {
        size: BUTTON_SIZES.medium,
    },
});
export const WixStyleReactDefaultsOverrideContext = context;
export const WixStyleReactDefaultsOverrideProvider = context.Provider;
export const WixStyleReactDefaultsOverrideConsumer = context.Consumer;
//# sourceMappingURL=WixStyleReactDefaultsOverrideProvider.js.map